import { service } from '@/utils/request'
const preApi = process.env.VUE_APP_ENV === 'development' ? '/dev' : ''
class assets {
  static getSaleFlowList (params) { return service.get(preApi + '/assetmanagement/sale_flow_list', { params }) } // 销售流水列表
  static getDrawRecordList (params) { return service.get(preApi + '/assetmanagement/withdrawal_record_list', { params }) } // 提现列表
  static taxCalculation (params) { return service.post(preApi + '/assetmanagement/tax_calculation', params) } // 税收计算
  static getUserAssets (params) { return service.get(preApi + '/assetmanagement/user_assets', { params }) } // 用户财产管理
  static withdrawaloperation (params) { return service.post(preApi + '/assetmanagement/withdrawal_operation', params) } // 提现操作
  static getMaterialCenter (params) { return service.get('/api/asset_management/material_center', { params }) } // 素材中心
  static getDataCenter (params) { return service.get('/api/asset_management/get_data_statistics', { params }) } // 数据中心
  static getDataTrend (params) { return service.get('/api/asset_management/get_data_trend', { params }) } // 数据中心趋势图
  static getExportEverydayStatistics (params) { return service.get(preApi + '/assetmanagement/export_everyday_statistics', { params }) } // 导出表单
}

export default assets
